
import BotonWhatsapp from "../components/BotonWhatsapp";

function Inicio() {
  return (
    <div>
     
      
      {/* Hero Section Simplificado */}
      <section className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold mb-6">
            Internet Ultra Rápido en Pujilí
          </h1>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            🎉 <strong>¡PROMOCIÓN 3 MESES!</strong> Desde 400 Mbps por solo $15.39
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0998106377"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors"
            >
              📞 Llama: 099 810 6377
            </a>
            <a 
              href="https://wa.me/593998106377?text=Hola Betalink Pujilí, me interesa la promoción"
              className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors"
            >
              💬 WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Planes Básicos */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            Planes Promocionales (3 meses)
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Plan Básico */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <h3 className="text-xl font-bold text-blue-600 mb-4">Básico</h3>
              <div className="text-4xl font-bold text-gray-800 mb-2">$15.39</div>
              <div className="text-2xl font-bold text-green-600 mb-6">400 Mbps</div>
              <a 
                href="https://wa.me/593998106377?text=Me interesa el plan Básico $15.39"
                className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold inline-block"
              >
                Contratar
              </a>
            </div>

            {/* Plan Estudiante */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <h3 className="text-xl font-bold text-green-600 mb-4">Estudiante</h3>
              <div className="text-4xl font-bold text-gray-800 mb-2">$17.70</div>
              <div className="text-2xl font-bold text-green-600 mb-6">600 Mbps</div>
              <a 
                href="https://wa.me/593998106377?text=Me interesa el plan Estudiante $17.70"
                className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition-colors font-semibold inline-block"
              >
                Contratar
              </a>
            </div>

            {/* Plan Tecnología */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <h3 className="text-xl font-bold text-purple-600 mb-4">Tecnología</h3>
              <div className="text-4xl font-bold text-gray-800 mb-2">$23.30</div>
              <div className="text-2xl font-bold text-purple-600 mb-6">800 Mbps</div>
              <a 
                href="https://wa.me/593998106377?text=Me interesa el plan Tecnología $23.30"
                className="w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 transition-colors font-semibold inline-block"
              >
                Contratar
              </a>
            </div>

            {/* Plan Gamer */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <h3 className="text-xl font-bold text-red-600 mb-4">Gamer</h3>
              <div className="text-4xl font-bold text-gray-800 mb-2">$30.60</div>
              <div className="text-2xl font-bold text-red-600 mb-6">1000 Mbps</div>
              <a 
                href="https://wa.me/593998106377?text=Me interesa el plan Gamer $30.60"
                className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition-colors font-semibold inline-block"
              >
                Contratar
              </a>
            </div>
          </div>
        </div>
      </section>

      <BotonWhatsapp />
    </div>
  );
}

export default Inicio;